import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        classifiers: '=',
        sites: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'tasklist.Choose employee' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div
                class="alert alert-danger"
                ng-if="vm.showError"
            >{{ 'tasklist.To continue, please choose an employee to whom you wish to assign the tasklist' | translate }}</div>
            <div class="table-filters">
                <form ng-submit="vm.applyFilter()" class="form form-filter">
                    <div class="fields">
                        <div class="row row-md row-flex02">
                            <label class="label">{{ 'filter.Name' | translate }}</label>
                            <div class="items"><input ng-model="vm.filter.name" type="text" class="form-control"></div>
                        </div>
                        <div class="row row-md row-flex02">
                            <label class="label">{{ 'filter.Site' | translate }}</label>
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.sites.options"
                                    selected-model="vm.multiFilter.sites.model"
                                    extra-settings="vm.multiFilter.sites.settings"
                                    ng-click="vm.updateEmployees()"
                                    translation-texts="vm.filterTranslations"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Department' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.departmentSelect.options"
                                    selected-model="vm.FilterService.departmentSelect.models"
                                    extra-settings="vm.FilterService.departmentSelect.settings"
                                    events="vm.FilterService.departmentSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </select>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Role' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.roleSelect.options"
                                    selected-model="vm.FilterService.roleSelect.models"
                                    extra-settings="vm.FilterService.roleSelect.settings"
                                    events="vm.FilterService.roleSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Level' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.levelSelect.options"
                                    selected-model="vm.FilterService.levelSelect.models"
                                    extra-settings="vm.FilterService.levelSelect.settings"
                                    events="vm.FilterService.levelSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">
                                {{ 'filter.Working since' | translate }}
                                <small>({{ 'filter.From' | translate }})</small>
                            </label>
                            <div class="items">
                                <datepicker-api ng-model="vm.filter.workingSinceFrom"></datepicker-api>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">
                                {{ 'filter.Working since' | translate }}
                                <small>({{ 'filter.To' | translate }})</small>
                            </label>
                            <div class="items">
                                <datepicker-api ng-model="vm.filter.workingSinceTo"></datepicker-api>
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                        <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                    </ul>
                <form/>
            </div>
            <div>
                <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
                <div class="well" ng-if="vm.list.items.length">
                    <pagination-tools list="vm.list" enable-all="true"></pagination-tools>
                    <table class="data01">
                        <thead>
                        <tr>
                            <th class="w1p nosort">&nbsp;</th>
                            <th>{{ 'user.First name' | translate }}</th>
                            <th>{{ 'user.Last name' | translate }}</th>
                            <th>{{ 'user.Position' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr ng-repeat="item in vm.list.items">
                            <td>
                                <input
                                    type="radio"
                                    name="r01"
                                    ng-model="vm.selectedUser"
                                    ng-value="item"
                                >
                            </td>
                            <td>{{ item.firstName }}</td>
                            <td>{{ item.lastName }}</td>
                            <td>
                                <drl-partial-table drls="item.drlsWithValue"></drl-partial-table>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <pagination list="vm.list"></pagination>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.continue()">{{ 'general.Continue' | translate}}</button>
                </li>
                <li>
                    <button
                        class="btn discrete"
                        type="button"
                        ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, ListFactory, CLASSIFIER_ENUM, ROLE_CODE_ENUM, TASKLIST_TASK_STATUS_ENUM,
                 UserService, UserResource, FilterService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.ListFactory = ListFactory;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.TASKLIST_TASK_STATUS_ENUM = TASKLIST_TASK_STATUS_ENUM;
        this.UserService = UserService;
        this.FilterService = FilterService;
        this.UserResource = UserResource;
    }

    $onInit () {
        this.selectedUser = null;
        this.defaultFilter = {};
        this.filter = angular.copy(this.defaultFilter);
        this.FilterService.init(this.classifiers);
        this.filterTranslations = this.FilterService.getTranslations();
        this.initMultiFilter();
        // this.list = this.ListFactory.createWithPagination(this.UserResource.query.bind(this.UserResource));
        this.list = this.ListFactory.createWithPagination(this.UserResource.getUsers.bind(this.UserResource));
        this.list.pagination.perPage = 25;
        this.applyFilter();
    }

    initMultiFilter () {
        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = siteOptions.map(site => site);

        this.multiFilter = {
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);
        this.filter = this.lodash.assign(this.filter, { siteIds });
        this.filter.departmentIds = this.FilterService.departmentSelect.models
            .filter(department => department.id !== null)
            .map(department => department.id);

        this.filter.roleIds = this.FilterService.roleSelect.models
            .filter(role => role.id !== null)
            .map(role => role.id);

        this.filter.levelIds = this.FilterService.levelSelect.models
            .filter(level => level.id !== null)
            .map(level => level.id);

        this.list.fetch({ expand: 'drlsWithValue' }, this.filter);
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.FilterService.initClassifierMultiFilter();
        this.selectedUser = null;
        this.applyFilter();
    }

    continue () {
        if (!this.selectedUser) {
            this.showError = true;
            return;
        }
        this.uibModalInstance.close(this.selectedUser);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/tasklist/employee/index.js